<template>
  <el-collapse v-model="collapseModel">
    <elemento-header
      :title="title"
      :name="name"
    >
      <input-suaje
        v-model="localModel"
        :validate="validarCotizacionCampos"
        v-bind="componentsProps.InputSuaje"
      />

      <input-procesos
        v-model="localModel.Secciones"
        :elemento-tipo="localModel.ElementoTipo"
      />

      <el-divider />
    </elemento-header>
  </el-collapse>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import {
  provide,
  ref,
  computed,
} from 'vue';
import { useElemento } from '@/shared/composables/useElemento.js';
import { usePricesStore } from '@/views/prices/stores/prices_store.js';
import InputProcesos from '@/shared/components/procesos/input_procesos.vue';
import InputSuaje from '@/shared/components/suaje/input_suaje.vue';
import { useComponentsProps } from '@/shared/composables/use_components_props.js';
import { useAnchoMinimoMM } from '@/shared/composables/use_ancho_minimo.js';
import { Modules } from '@/enum/modules';
import { ElementoBase } from '@/enum/elemento_base';

const emit = defineEmits(['update:modelValue']);

const pricesStore = usePricesStore();
const { validarCotizacionCampos } = storeToRefs(pricesStore);
const { componentsProps } = useComponentsProps(ElementoBase.BOLSAS_BOX, Modules.COTIZACION);

const props = defineProps({
  modelValue: { type: Object, required: true },
  title: { type: String, required: true },
  name: { type: String, required: true },
});

const { localModel, collapseModel, updateModelo } = useElemento(props, emit);
const { anchoMinimoMM } = useAnchoMinimoMM(localModel);
const selectedMaterialAnchoMM = ref(0);
provide('currentModule', Modules.COTIZACION);
provide('anchoMinimoMM', anchoMinimoMM);
provide('currentElementoBase', ElementoBase.BOLSAS_BOX);
provide('selectedMaterialAnchoMM', selectedMaterialAnchoMM);

// Proveer valores de imposición para componentes de proceso
const imposicionProvidedValue = computed(() => ({
  EtiquetasEje: localModel.value.EtiquetasEje || 0,
  EtiquetasDesarrollo: localModel.value.EtiquetasDesarrollo || 0,
}));

provide('imposicion', imposicionProvidedValue);
</script>
